// extracted by mini-css-extract-plugin
export default {"NewsItem":"index_NewsItem_fWniC","listItem":"index_listItem_OQEX6","text":"index_text_Sc-vk"};